import * as Cookies from "js-cookie";
const key = "__auth__";

const writeCookie = value => {
  Cookies.set(key, value, { secure: false });
};

const state = Cookies.getJSON(key) || { isAuth: false, user: null };

const mutations = {
  login: (state, user) => {
    state.isAuth = true;
    state.user = user;
    writeCookie(state);
  },
  logout: state => {
    state.isAuth = false;
    state.user = null;
    writeCookie(state);
  }
};

export default { state, mutations };
